import { render, staticRenderFns } from "./RetailList.vue?vue&type=template&id=11a09562&scoped=true"
import script from "./RetailList.vue?vue&type=script&lang=js"
export * from "./RetailList.vue?vue&type=script&lang=js"
import style0 from "./RetailList.vue?vue&type=style&index=0&id=11a09562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a09562",
  null
  
)

export default component.exports